import { createValueInColumnCell } from "./createValueInColumnCell";

export const createColumns = (columns) =>
  columns.map((key) => createValueInColumnCell(columns)[key]);
